import React from 'react'
import { PulseLoader } from 'react-spinners'
import styled from 'styled-components'
import theme from '~/design'

const Wrapper = styled.div`
  display: flex;
  height: 100%;
  flex: 1;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: ${({ theme }) => theme.padding(2)};
`

export const StyledPulseLoader = styled(PulseLoader)`
  color: ${({ theme }) => theme.colors.primary};
`

export default function Loader() {
  return (
    <Wrapper>
      <StyledPulseLoader />
    </Wrapper>
  )
}
